import { SubmitUserDetailsSuccess } from 'ouisys-engine/dist/reducers/creditCardFlow/CreditCardTypes';
import { tracker } from 'ouisys-engine/dist/reducers/strategy';
import * as React from 'react';
import { injectIntl, Translate } from '../../localization/index';
import './CreditCardStep.scss';

const wpwlOptions = { style: "plain" };


//add checkbox function
const addCheckBox = () => {
  if (typeof window != 'undefined') {
    console.log("checkbox will appear after 2.5 sec")
    const wpwlButtonPay = document.querySelector('.wpwl-button.wpwl-button-pay');
    if (wpwlButtonPay) {
      const newDiv = document.createElement('div');

      if (document.documentElement.lang === "es") {
        // Do something if lang is "fr" (French)
        newDiv.innerHTML = '<form><label class="cheeckbox-wrap"><input checked type="checkbox" required=""><p>Al registrarse en nuestra página web, confirma que acepta los <a href="https://portal.fun-box.net/terms-and-conditions" target="_blank">Términos y condiciones</a>&nbsp;,&nbsp;&nbsp;<a class="each" href="https://portal.fun-box.net/privacy-policy" target="_blank">política de privacidad</a>&nbsp;,&nbsp;&nbsp;y se suscribe voluntariamente a nuestro servicio de suscripción, lo que le garantiza recibir todos los beneficios de nuestra plataforma.</p></label></form>';
      } else if (document.documentElement.lang === "fr") {
        newDiv.innerHTML = '<form><label class="cheeckbox-wrap"><input checked type="checkbox" required=""><p>En vous inscrivant sur notre site Web, vous confirmez votre acceptation des <a href="https://portal.fun-box.net/terms-and-conditions" target="_blank">Termes et Conditions</a>&nbsp;,&nbsp;&nbsp;<a class="each" href="https://portal.fun-box.net/privacy-policy" target="_blank">Politique de confidentialité</a>&nbsp;,&nbsp;&nbsp;et vous optez volontairement pour notre service d’abonnement. Vous bénéficiez ainsi de tous les avantages de notre plate-forme.</p></label></form>';
      } else {
        newDiv.innerHTML = '<form><label class="cheeckbox-wrap"><input checked type="checkbox" required=""><p>By signing up for our website, you confirm your acceptance of the <a href="https://portal.fun-box.net/terms-and-conditions" target="_blank">Terms &amp; Conditions</a>&nbsp;,&nbsp;&nbsp;<a class="each" href="https://portal.fun-box.net/privacy-policy" target="_blank">Privacy Policy</a>&nbsp;,&nbsp;&nbsp;and voluntarily opt into our subscription service, ensuring you receive the full benefits of our platform.</p></label></form>';
      }

      wpwlButtonPay.parentNode.insertBefore(newDiv, wpwlButtonPay);
    }
  }
};

const CreditCardStep = ({ gateway_url }: SubmitUserDetailsSuccess) => {
  React.useEffect(() => {

    if (typeof window != 'undefined') {
      tracker.advancedInFlow('tallyman.v1-credit-card', 'click', { gateway_url });
      window.location.href = gateway_url;

          setTimeout(addCheckBox, 2500); //this function will load the checkbox - the timeout needed to be there because it need to load after the payment forms loaded


    }

    // var wpwlButtonPay = document.querySelector('.wpwl-button.wpwl-button-pay');
    // if (wpwlButtonPay) {
    //   var newDiv = document.createElement('div');
    //   newDiv.textContent = 'New div added above wpwl-button-pay';
    //   wpwlButtonPay.parentNode.insertBefore(newDiv, wpwlButtonPay);
    // }

  }, []);
  return (
    <div>
      <div className="wpwl-container">
        <form className="paymentWidgets" data-brands="VISA MASTER"></form>
      </div>


      {/* the codes below im trying to customize the html */}

      {/* <div className="wpwl-container">
        <form className="paymentWidgets" data-brands="VISA MASTER" autoComplete="on">
          <div className="wpwl-group wpwl-group-brand wpwl-clearfix">
            <div className="wpwl-label wpwl-label-brand">Brand</div>
            <div className="wpwl-wrapper wpwl-wrapper-brand">
              <select className="wpwl-control wpwl-control-brand" name="paymentBrand">
                <option value="MASTER">Mastercard</option>
                <option value="VISA">Visa</option>
              </select>
            </div>
            <div className="wpwl-brand wpwl-brand-card wpwl-brand-MASTER"></div>
          </div>
          <div className="wpwl-group wpwl-group-cardNumber wpwl-clearfix">
            <div className="wpwl-label wpwl-label-cardNumber">Card Number</div>
            <div className="wpwl-wrapper wpwl-wrapper-cardNumber">
              <input autoComplete="on" type="tel" name="card.number" className="wpwl-control wpwl-control-cardNumber" placeholder="Card Number" />
            </div>
          </div>
          <div className="wpwl-group wpwl-group-expiry wpwl-clearfix">
            <div className="wpwl-label wpwl-label-expiry">Expiry Date</div>
            <div className="wpwl-wrapper wpwl-wrapper-expiry">
              <input autoComplete="cc-exp" type="tel" name="cc-exp" className="wpwl-control wpwl-control-expiry" placeholder="MM / YY" />
            </div>
          </div>
          <div className="wpwl-group wpwl-group-cardHolder wpwl-clearfix">
            <div className="wpwl-label wpwl-label-cardHolder">Card holder</div>
            <div className="wpwl-wrapper wpwl-wrapper-cardHolder">
              <input autoComplete="on" type="text" name="card.holder" className="wpwl-control wpwl-control-cardHolder" placeholder="Card holder" />
            </div>
          </div>
          <div className="wpwl-group wpwl-group-cvv wpwl-clearfix">
            <div className="wpwl-label wpwl-label-cvv">CVV</div>
            <div className="wpwl-wrapper wpwl-wrapper-cvv">
              <input autoComplete="cc-csc" type="tel" name="cc-csc" className="wpwl-control wpwl-control-cvv" placeholder="CVV" />
            </div>
          </div>
          <div className="wpwl-group wpwl-group-submit wpwl-clearfix">
            <div className="wpwl-wrapper wpwl-wrapper-submit">
              <button type="submit" name="pay" className="wpwl-button wpwl-button-pay">Pay now</button>
            </div>
          </div>
          <div className="form-group">
            <label className="cheeckbox-wrap">
              <input type="checkbox" required />
              <p>
                <Translate id="regCheckbox1" defaultMessage="By signing up for our website, you confirm your acceptance of the "></Translate>
                <a href="https://portal.fun-box.net/terms-and-conditions" target="_blank">
                  <Translate id="terms-conditions" defaultMessage="Terms & Conditions"></Translate>
                </a>&nbsp;,&nbsp;&nbsp;
                <a className="each" href="https://portal.fun-box.net/privacy-policy" target="_blank">
                  <Translate id="privacy-policy" defaultMessage="Privacy Policy"></Translate>
                </a>&nbsp;,&nbsp;&nbsp;
                <Translate id="regCheckbox2" defaultMessage="and voluntarily opt into our subscription service, ensuring you receive the full benefits of our platform"></Translate>
                .</p>
            </label>
          </div>
          <input type="hidden" name="card.expiryMonth" value="" />
          <input type="hidden" name="card.expiryYear" value="" />
        </form>
      </div> */}


    </div>
  );
};

export default injectIntl(CreditCardStep);
